/* Grade de camisetas do tema 360 (home, coleção e busca): abas por tema, ordenação,
   som ao passar pelas peças e a compra rápida (carregada só no toque).
   Depende de base.js (SK8.som). Configuração vem dos data-* da própria tag <script>:
   data-compra-rapida (JS), data-compra-rapida-css, data-pix e data-parcelas.

   Abas: os links levam a ?grupo=monster | skate-surfe | caveiras. O template põe
   data-grupo no <html> antes da grade aparecer (o CSS filtra); aqui o clique filtra
   sem recarregar, atualiza a contagem, o estado vazio e o endereço.
   Compra rápida: o botão "+" do cartão chama compra-rapida.js, que só é baixado
   quando alguém toca, passa o mouse ou foca o botão. */
(function () {
  "use strict";
  var SK8 = window.SK8 || {};
  var tocar = function (n) { if (SK8.som) SK8.som.tocar(n); };
  var tag = document.currentScript || document.querySelector("script[data-compra-rapida]");
  var cfg = (tag && tag.dataset) || {};
  var GRUPOS = ["monster", "skate-surfe", "caveiras"];

  /* abas por tema: Todas, Monster, Skate e surfe, Caveiras (data-grupo das peças, vindo das tags) */
  document.querySelectorAll("[data-filtros]").forEach(function (barra) {
    var grade = document.querySelector(barra.getAttribute("data-filtros"));
    if (!grade) return;
    var vazio = document.querySelector("[data-grupo-vazio]");
    var cont = document.querySelector("[data-vitrine-contagem]");
    function aplicar(g, mudarEndereco) {
      var raiz = document.documentElement;
      var ativo = GRUPOS.indexOf(g) >= 0 ? g : "todas";
      if (ativo === "todas") raiz.removeAttribute("data-grupo"); else raiz.setAttribute("data-grupo", ativo);
      barra.querySelectorAll("[data-filtro]").forEach(function (x) {
        if (x.getAttribute("data-filtro") === ativo) x.setAttribute("aria-current", "true"); else x.removeAttribute("aria-current");
      });
      var n = 0;
      grade.querySelectorAll(".peca").forEach(function (p) {
        if (ativo === "todas" || (" " + p.getAttribute("data-grupo") + " ").indexOf(" " + ativo + " ") >= 0) n++;
      });
      if (cont) cont.textContent = n + (n === 1 ? " camiseta" : " camisetas");
      if (vazio) vazio.hidden = n > 0;
      if (mudarEndereco && window.history && history.replaceState) {
        try {
          var u = new URL(location.href);
          if (ativo === "todas") u.searchParams.delete("grupo"); else u.searchParams.set("grupo", ativo);
          history.replaceState(null, "", u.pathname + u.search + u.hash);
        } catch (e) {}
      }
    }
    barra.addEventListener("click", function (e) {
      var b = e.target.closest("[data-filtro]");
      if (!b || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault();
      aplicar(b.getAttribute("data-filtro"), true);
      tocar("canal");
    });
    var limpar = document.querySelector("[data-filtro-limpar]");
    if (limpar) limpar.addEventListener("click", function (e) { e.preventDefault(); aplicar("todas", true); });
    var pedido = null;
    try { pedido = new URLSearchParams(location.search).get("grupo"); } catch (e) {}
    aplicar(pedido, false);
  });

  /* ordenação: troca o sort_by e mantém o tema escolhido */
  document.querySelectorAll("[data-ordenar]").forEach(function (form) {
    var campo = form.querySelector("[data-ordenar-campo]");
    if (!campo) return;
    campo.addEventListener("change", function () {
      try {
        var u = new URL(location.href);
        u.searchParams.set("sort_by", campo.value);
        u.searchParams.delete("page");
        location.href = u.pathname + u.search;
      } catch (e) { form.submit(); }
    });
  });

  /* som ao passar o mouse pelas peças */
  var ultima = null, movendo = false;
  document.addEventListener("pointerover", function (e) {
    if (e.pointerType && e.pointerType !== "mouse") return;
    var p = e.target.closest && e.target.closest(".peca-link");
    if (p && p !== ultima && !movendo) { movendo = true; ultima = p; requestAnimationFrame(function () { movendo = false; }); tocar("mover"); }
  });
  document.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest(".peca-link")) tocar("confirmar");
  }, true);

  /* compra rápida: o JS e o CSS dela só descem quando alguém chega perto do botão */
  var carga = null;
  function carregarRapida() {
    if (window.SK8CompraRapida) return Promise.resolve(window.SK8CompraRapida);
    if (!cfg.compraRapida) return Promise.reject(new Error("sem endereço"));
    if (!carga) {
      carga = new Promise(function (ok, erro) {
        if (cfg.compraRapidaCss) {
          var l = document.createElement("link");
          l.rel = "stylesheet"; l.href = cfg.compraRapidaCss;
          document.head.appendChild(l);
        }
        var s = document.createElement("script");
        s.src = cfg.compraRapida;
        s.onload = function () { if (window.SK8CompraRapida) ok(window.SK8CompraRapida); else { carga = null; erro(new Error("falhou")); } };
        s.onerror = function () { carga = null; erro(new Error("falhou")); };
        document.head.appendChild(s);
      });
    }
    return carga;
  }
  function doBotao(e) { return e.target.closest && e.target.closest("[data-compra-rapida]"); }
  ["pointerover", "touchstart", "focusin"].forEach(function (ev) {
    document.addEventListener(ev, function (e) { if (doBotao(e)) carregarRapida().catch(function () {}); }, { passive: true });
  });
  document.addEventListener("click", function (e) {
    var b = doBotao(e);
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute("aria-busy") === "true") return;
    b.setAttribute("aria-busy", "true");
    carregarRapida().then(function (m) {
      b.removeAttribute("aria-busy");
      m.abrir(b, { pix: Number(cfg.pix), parcelas: Number(cfg.parcelas) });
    }).catch(function () {
      // sem o painel, a pessoa segue para a página da camiseta e escolhe lá
      b.removeAttribute("aria-busy");
      var a = b.closest(".peca") && b.closest(".peca").querySelector(".peca-link");
      if (a) location.href = a.href;
    });
  });
})();
